import { Icon, type IconName } from '../../components/ui/Icon';
import './dashboard.css';

interface InfoTileProps {
  label: string;
  value: string;
  icon: IconName;
  /**
   * Share of a stated whole, 0–1. Rendered as a meter with a written caption,
   * so the proportion is never conveyed by the bar alone.
   */
  share?: number;
  shareCaption?: string;
}

const clampShare = (share: number): number => Math.min(1, Math.max(0, share));

/**
 * Secondary metric row: tinted icon chip, value, label, and an optional
 * proportion meter. Used for counters that are meaningful next to a total.
 */
export function InfoTile({ label, value, icon, share, shareCaption }: InfoTileProps) {
  const hasShare = typeof share === 'number' && Number.isFinite(share);
  const percent = hasShare ? Math.round(clampShare(share) * 100) : 0;

  return (
    <article className="dash-info">
      <span className="dash-info__chip">
        <Icon name={icon} />
      </span>
      <div className="dash-info__body">
        <p className="dash-info__value">{value}</p>
        <p className="dash-info__label">{label}</p>
        {hasShare ? (
          <>
            <span className="dash-info__meter">
              <span
                className="dash-info__meter-fill"
                style={{ width: `${percent}%` }}
                aria-hidden="true"
              />
            </span>
            {shareCaption ? (
              <p className="dash-info__caption">{shareCaption}</p>
            ) : null}
          </>
        ) : null}
      </div>
    </article>
  );
}
